import _ from 'lodash';
import { useEffect, useState } from 'react';
import Checkbox from '../../../../../../common/widgets/Checkbox';
import Icons from '../../../../../../common/widgets/Icons';
import Loader from '../../../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../../../common/widgets/LoadingSpinner';
import { TaxFilter } from '../../../../models/Filters';
import { getSelectedTaxClassIds, mapToTaxFilterItems } from '../helpers';
import { TaxFilterItem } from '../types';

interface TaxationLevelFilterProps {
  taxationLevelList?: TaxFilter[];
  prevSelectedTaxClassIds?: number[];
  handleTaxFilterChanged: (taxClassIds: number[]) => void;
  title: string;
}

export default function TaxationLevelFilter(
  props: Readonly<TaxationLevelFilterProps>,
) {
  const {
    taxationLevelList,
    prevSelectedTaxClassIds,
    handleTaxFilterChanged,
    title,
  } = props;
  const [filterItems, setFilterItems] = useState<TaxFilterItem[]>();
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  useEffect(() => {
    if (taxationLevelList) {
      setFilterItems(
        mapToTaxFilterItems(taxationLevelList, prevSelectedTaxClassIds ?? []),
      );
    }
  }, [taxationLevelList, prevSelectedTaxClassIds]);

  const handleOnclick = (item: TaxFilterItem) => {
    item.isChecked = !item.isChecked;
    const taxClassIds = getSelectedTaxClassIds(filterItems ?? []);
    handleTaxFilterChanged(taxClassIds);
  };

  if (!filterItems) {
    return <></>;
  }

  return (
    <Loader loading={!taxationLevelList} loader={<LoadingSpinner />}>
      <div
        className={`action-panel expandable expand-on-arrow ${
          isExpanded ? '' : 'collapsed'
        }`}
      >
        <div className="action-panel-title">
          <span>{title}</span>
          <span
            className="action-panel-expand"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Icons.ArrowUp />
          </span>
        </div>

        {isExpanded && (
          <div className="action-panel-content">
            {!!filterItems &&
              _.map(filterItems, (ti: TaxFilterItem) => {
                return (
                  <div key={`${ti.taxRate}`} className="filter-checkbox">
                    <Checkbox
                      isChecked={ti.isChecked}
                      label={`${ti.taxRate}%`}
                      onChange={() => handleOnclick(ti)}
                      onLabelClick={() => handleOnclick(ti)}
                    />
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </Loader>
  );
}
